import { MD5 } from 'crypto-js'
import { singleRunPromise } from '../common/adapter'
import { getTimestamp } from '../common/dayjs2'
import { appId, appKey } from '@/config/http.config'
import { getToken as getTokenContext, getAuthToken as getAuthTokenContext, setToken, setAuthToken } from '../context/authorization'
import { requrstShowErrorState, setRequrstShowErrorState } from '../context/http'
import { getUserLoginSessionKey } from '../context/user'
import { showModal } from '../pageApi/tip'
import { gotoError106 } from '../router'
import { getToken as _getToken, getAuthToken as _getAuthToken } from '../services'
import { getApiType } from '@/context/user'

/** 获取token */
export async function getToken() {
  const token = await getTokenContext()
  if (token) {
    return token
  }

  return await singleRunPromise('parameter_getToken', async function () {
    const res = await _getToken({})

    if (res[1] && res[1].data.status === 'success' && res[1].data.data) {
      setToken(res[1].data.data)
    } else {
      if (!requrstShowErrorState) {
        console.warn('获取token失败')
        gotoError106()
        // setRequrstShowErrorState(true)
        // showModal({
        //   icon: 'error',
        //   title: '获取token失败',
        //   content: res[0],
        //   onOk: () => {
        //     setRequrstShowErrorState(false)
        //   }
        // })
      }
    }

    return await getTokenContext()
  })
}

/** 获取token，用于鉴权 */
export async function getAuthToken() {
  const token = await getAuthTokenContext()
  if (token) {
    return token
  }

  return await singleRunPromise('parameter_getAuthToken', async function () {
    const param = {
      appid: appId,
      appkey: appKey,
      noncestr: Math.random().toString().substring(2),
      timestamp: getTimestamp().toString()
    }
    param.sign = paramsSign(param)
    delete param.appkey

    const res = await _getAuthToken(param)
    if (res[1] && res[1].status === 200 && res[1].data.Data && res[1].data.Data.Token) {
      setAuthToken(res[1].data.Data.Token)
    } else {
      if (!requrstShowErrorState) {
        console.warn('获取token失败')
        gotoError106()
      }
    }
    return await getAuthTokenContext()
  })
}

/**
 * 创建系统级别输入参数
 * @param {*} param2 业务参数
 */
export async function createParams(...param2) {
  const params = {}

  if (param2) Object.assign(params, ...param2)
  return params
}

/**
 * 新版鉴权
 * @param {*} httpObject
 */
export async function createHeader(httpObject) {
  const appkey = appKey
  let header = {
    'content-type': 'application/json'
  }
  const apptoken = await getToken()
  if (getApiType() !== 'cy') {
    const authApptoken = await getAuthToken()
    // 零售应用中心开放鉴权，增加专属token，路由传入的token修改传参字段名为identitytoken
    header.apptoken = authApptoken
    header.identitytoken = apptoken
    // console.log('createHeader---', authApptoken, apptoken)
  } else {
    header.apptoken = apptoken
    // console.log('createHeader---', apptoken)
  }
  header.sisscloudtokenid = getUserLoginSessionKey() || ''
  header.timestamp = getTimestamp().toString()
  header.noncestr = Math.random().toString().substring(2)
  let params = {
    apptoken: header.apptoken,
    sisscloudtokenid: header.sisscloudtokenid,
    appkey: appkey,
    noncestr: header.noncestr,
    timestamp: header.timestamp
  }
  if (getApiType() !== 'cy') {
    params.identitytoken = header.identitytoken
  }
  // 与api未达成一致
  // for (const key in httpObject.params) {
  //   if (Object.hasOwnProperty.call(httpObject.params, key)) {
  //     const element = httpObject.params[key]
  //     httpObject.params[key] = encodeURIComponent(element)
  //   }
  // }
  params = Object.assign(params, httpObject.data, httpObject.params)
  // httpObject.signParams = params
  header.sign = paramsSign(params)

  if (httpObject.header2) {
    header = Object.assign(header, httpObject.header2)
  }

  return header
}

/**
 * 对参数进行签名
 * @param {*} params
 */
export function paramsSign(params) {
  let ss = []
  const keys = Object.keys(params).sort()

  for (const i in keys) {
    const value = params[keys[i]]
    if (value == undefined) {
      continue
    } else if (value.constructor == Array || value.constructor == Object) {
      ss.push(keys[i] + '=' + JSON.stringify(params[keys[i]]))
      // eslint-disable-next-line brace-style
    }
    // else if (value.constructor == Object) {
    //   ss.push(keys[i] + '=' + objectSortToStringify(params[keys[i]]))
    // }
    else if (value != undefined && value.toString().trim() != '') {
      // Number、Boolean、String
      ss.push(keys[i] + '=' + params[keys[i]])
    }
  }
  ss = ss.join('&')
  // console.log('sign string : ', ss) //console.log('sign string : ', params,keys)

  const signStr = MD5(ss).toString().toUpperCase()
  return signStr
}

/**对象属性排序后转换为字符串 */
function objectSortToStringify(obj) {
  const keys = Object.keys(obj)
    // .filter((key) => obj[key] !== null && obj[key] !== undefined)
    .sort()
  return JSON.stringify(obj, keys)
}
